import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { RecallFormItem } from 'src/app/models';
import { DynamicComponent } from 'src/app/components/base/dynamic.component';
import { PluginService } from 'src/app/services';

@Component({
  selector: 'recallform-item-component',
  templateUrl: './recallform.item.component.html',
  styleUrls: ['./recallform.item.component.less']
})
export class RecallFormComponent extends DynamicComponent implements OnInit {

  constructor(public pluginService: PluginService) {
    super(pluginService);
  }

  @Input() item: RecallFormItem;
  @Input() allsectionitems: RecallFormItem[];

  @Output() delete = new EventEmitter<void>();

  tableFields: string[] = [
    'name',
    'surname',
    'phone',
    'email',
    'address',
    'suburb',
    'country',
    'state',
    'postcode',
    'access information',
    'recall information',
    'power',
    'type of installation',
    'part number and model',
    'serial number',
    'front image',
    'side image',
    'serial image',
    'delivery availability',
    'elaborate details'
  ];

  dropdownItems: Array<{ key: string, value: string, salesforceId?: string }> = [];

  ngOnInit() {
    this.updateDropdownItems();
  }

  updateDropdownItems(): void {
    if (this.item.field_2) {
      try {
        console.log(this.item.field_2);
        this.dropdownItems = JSON.parse(this.item.field_2) || [];
      } catch (e) {
        console.error('Invalid JSON in field_2', e);
        this.dropdownItems = [];
      }
    }
  }


  setValue(i, e) {
    if (e.checked) {
      this.item.field_6 = 1;
    } else {
      this.item.field_6 = 0;
    }
  }

  getValue() {
    return this.item.field_6 == 1 ? true : false;
  }

  addDropdownItem() {
    this.dropdownItems.push({ key: '', value: '', salesforceId: '' });
    this.updateField2();
  }

  deleteDropdownItem(index: number) {
    this.dropdownItems.splice(index, 1);
    this.updateField2();
  }

  updateField2() {
    this.item.field_2 = JSON.stringify(this.dropdownItems);
  }
}
